<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="closeDialog" />

    <div>
      <div class="d-flex justify-center mb-8">
        <h2 class="font-weight-bold">
          {{ title }}
        </h2>
      </div>

      <!--ADDRESS NAME-->
      <v-row>
        <v-col>
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.NAME') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.name"
            :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.NAME')"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <!--ADDRESS NUMBER-->
        <v-col cols="md-4">
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.NUMBER') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.number"
            :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.NUMBER')"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
        <!--ADDRESS STREET-->
        <v-col cols="md-8">
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.STREET') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.street"
            :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.STREET')"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <!--ADDITIONAL 1-->
      <v-row>
        <v-col>
          <p>
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.COMPLEMENT_ONE') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.complementOne"
            :placeholder="
              $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.COMPLEMENT_ONE')
            "
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <!--ADDITIONAL 2-->
      <v-row>
        <v-col>
          <p>
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.COMPLEMENT_TWO') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.complementTwo"
            :placeholder="
              $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.COMPLEMENT_TWO')
            "
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <!--ZIP CODE-->
        <v-col cols="6">
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.ZIP_CODE') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.zipCode"
            :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.ZIP_CODE')"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>

        <!--CITY-->
        <v-col cols="6">
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.CITY') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.city"
            :placeholder="$t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.PLACEHOLDER.CITY')"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <!--CONTACT NAME-->
      <v-row>
        <v-col>
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.CONTACT_NAME') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.contactName"
            :rules="requiredRules"
            required
            hide-details
          />
        </v-col>
      </v-row>

      <!--CONTACT EMAIL-->
      <v-row>
        <v-col>
          <p data-custom="true">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.CONTACT_EMAIL') }}
          </p>
          <v-text-field
            v-model.trim="addressInfo.contactEmail"
            :rules="requiredRules"
            required
            hide-details
            :error-messages="error?.contactEmail"
          />
        </v-col>
      </v-row>

      <!--CONTACT PHONE-->
      <v-row>
        <v-col>
          <p data-rgpd="true" class="content-title">
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.CONTACT_PHONE') }}
          </p>
          <v-phone-input
            v-model="addressInfo.contactPhone"
            v-model:country="selectedCountry"
            :error-messages="error?.contactPhone"
            :includeCountries="allCountries"
            :rules="requiredRules"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4" offset="4">
          <v-btn
            :disabled="
              !addressInfo.city ||
              !addressInfo.zipCode ||
              !addressInfo.street ||
              !addressInfo.number ||
              !addressInfo.name ||
              !addressInfo.contactName ||
              !addressInfo.contactEmail ||
              !addressInfo.contactPhone
            "
            class="boom-button dialog-button"
            variant="outlined"
            @click="_confirm"
          >
            {{ $t('FILE_STEP_TRANSPORT_MODALITY.MODAL.ADDRESS.VALIDATION_BUTTON') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import { VPhoneInput } from 'v-phone-input'
import Validator from '@/components/utils/validator'
import RegionCodeService from '@/services/RegionCodeService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'AddressModal',
  components: { DialogCloseButton, VPhoneInput, PopupModal },
  data: () => ({
    addressInfo: undefined,

    title: undefined,

    selectedCountry: 'FR',
    allCountries: [],

    resolvePromise: undefined,
    rejectPromise: undefined,

    error: null,

    requiredRules: Validator.requiredRules,
  }),
  methods: {
    async show(opts = {}) {
      const response = await RegionCodeService.getRegionCodeList()
      this.allCountries = await this.getCountryCode(response.item_list)
      this.selectedCountry = 'FR'

      this.addressInfo = Object.assign({}, opts.addressInfo)
      this.title = opts.title

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        addressInfo: this.addressInfo,
        confirmed: true,
        selection: this.selected
      })
    },
    closeDialog() {
      this.$refs.popup.close()
    },
    getCountryCode(zones) {
      return zones.map((item) => {
        return item.country_code
      })
    }
  }
}
</script>

<style scoped>
.dialog-button {
  min-width: 200px;
}
</style>
